import React from "react";
import { BeforeAfterColumns } from "../BeforeAfterColumns";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { beforeSystem, withSystem } from "../../data/landing";
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-107" data-mp="26k04imtveq2k">
      <div className="mx-auto max-w-5xl" data-id="element-108" data-mp="22lsro32j28wn">
        <SectionHeading eyebrow="Before vs. after" title={<>
              What changes when you use a <em className="italic text-gold-dark" data-id="element-110" data-mp="2ubfcav4f1zl7">structured</em> case-planning system?
            </>} data-id="element-109" data-mp="22iy2jy8kjzww" />
        <div className="mt-10" data-id="element-111" data-mp="2q9am66d6fl3b">
          <BeforeAfterColumns beforeTitle="Before" afterTitle="With Lipo Planning Workbook™" before={beforeSystem} after={withSystem} data-id="element-112" data-mp="2q8iqywnhrpdk" />
        </div>
        <div className="mt-10" data-id="element-113" data-mp="1evq1xtm35f17">
          <CtaButton label="I want to plan cases with a system" data-id="element-114" data-mp="1ewrnwt4n3lxp" />
        </div>
      </div>
    </section>;
}